module.exports = __webpack_public_path__ + "static/media/fin-logo.45fca973.png";